/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Admins.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  ErrorDescription,
  PatientPackageApiOutContract,
  PatientPackageCancellationAdminApiInContract,
  PatientPackageVisitsAdjustmentAdminApiInContract
} from '../pwrdbyQuickMDAdminsApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * # Possible Errors
| HTTP status | ErrorCode           | Description                                              |
|-------------|---------------------|----------------------------------------------------------|
| 404         | PatientNotFound     | The patient with the specified ID could not be found.    |
 * @summary Retrieves every package a patient has bought, newest first, with the balance left on each visit type it
covers.
 */
export const getPatientsPatientIdPackages = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PatientPackageApiOutContract[]>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/packages`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdPackagesInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/patients/${patientId}/packages`
    ] as const;
    }

export const getGetPatientsPatientIdPackagesQueryKey = (patientId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/patients/${patientId}/packages`
    ] as const;
    }

    
export const getGetPatientsPatientIdPackagesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPackagesInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>> = ({ signal }) => getPatientsPatientIdPackages(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPackagesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>
export type GetPatientsPatientIdPackagesInfiniteQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetPatientsPatientIdPackagesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPackages>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPackages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPackagesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPackages>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPackages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPackagesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves every package a patient has bought, newest first, with the balance left on each visit type it
covers.
 */

export function useGetPatientsPatientIdPackagesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPackagesInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves every package a patient has bought, newest first, with the balance left on each visit type it
covers.
 */
export const prefetchGetPatientsPatientIdPackagesInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdPackagesInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdPackagesQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPackagesQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>> = ({ signal }) => getPatientsPatientIdPackages(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPackagesQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>
export type GetPatientsPatientIdPackagesQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetPatientsPatientIdPackages<TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPackages>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPackages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPackages<TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPackages>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPackages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPackages<TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves every package a patient has bought, newest first, with the balance left on each visit type it
covers.
 */

export function useGetPatientsPatientIdPackages<TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPackagesQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves every package a patient has bought, newest first, with the balance left on each visit type it
covers.
 */
export const prefetchGetPatientsPatientIdPackagesQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdPackagesQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdPackagesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPackagesQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>> = ({ signal }) => getPatientsPatientIdPackages(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPackagesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>
export type GetPatientsPatientIdPackagesSuspenseQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetPatientsPatientIdPackagesSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPackagesSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPackagesSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves every package a patient has bought, newest first, with the balance left on each visit type it
covers.
 */

export function useGetPatientsPatientIdPackagesSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPackagesSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdPackagesSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPackagesInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>> = ({ signal }) => getPatientsPatientIdPackages(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPackagesSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>
export type GetPatientsPatientIdPackagesSuspenseInfiniteQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetPatientsPatientIdPackagesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPackagesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPackagesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves every package a patient has bought, newest first, with the balance left on each visit type it
covers.
 */

export function useGetPatientsPatientIdPackagesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPackages>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPackagesSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * # Possible Errors
| HTTP status | ErrorCode                     | Description                                                        |
|-------------|-------------------------------|--------------------------------------------------------------------|
| 400         | BadRequest                    | Adjustments is empty, or names a visit type blank or twice.        |
| 400         | ReasonNotValid                | A reason is required.                                               |
| 400         | PackageVisitsRemainingNotValid| A new balance would fall outside [0, AllowedQuantity].             |
| 403         | Permission                    | The admin lacks the patient.package.edit permission.               |
| 404         | PatientNotFound               | The patient could not be found.                                    |
| 404         | PackageNotFound               | The patient holds no package with the specified identifier.        |
| 404         | PackageVisitTypeNotFound      | The package does not cover a requested visit type.                 |
| 409         | PackageExpired                | The package has expired and cannot be adjusted.                    |
 * @summary Adjusts the remaining visit balance on a patient's package by a signed delta per visit type and records an
audit entry. The whole request is applied together, so an invalid entry leaves every balance untouched.
 */
export const putPatientsPatientIdPackagesPatientPackageIdVisits = (
    patientId: string,
    patientPackageId: string,
    patientPackageVisitsAdjustmentAdminApiInContract: PatientPackageVisitsAdjustmentAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/packages/${encodeURIComponent(String(patientPackageId))}/visits`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: patientPackageVisitsAdjustmentAdminApiInContract
    },
      options);
    }
  


export const getPutPatientsPatientIdPackagesPatientPackageIdVisitsMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdPackagesPatientPackageIdVisits>>, TError,{patientId: string;patientPackageId: string;data: PatientPackageVisitsAdjustmentAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdPackagesPatientPackageIdVisits>>, TError,{patientId: string;patientPackageId: string;data: PatientPackageVisitsAdjustmentAdminApiInContract}, TContext> => {

const mutationKey = ['putPatientsPatientIdPackagesPatientPackageIdVisits'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPatientsPatientIdPackagesPatientPackageIdVisits>>, {patientId: string;patientPackageId: string;data: PatientPackageVisitsAdjustmentAdminApiInContract}> = (props) => {
          const {patientId,patientPackageId,data} = props ?? {};

          return  putPatientsPatientIdPackagesPatientPackageIdVisits(patientId,patientPackageId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPatientsPatientIdPackagesPatientPackageIdVisitsMutationResult = NonNullable<Awaited<ReturnType<typeof putPatientsPatientIdPackagesPatientPackageIdVisits>>>
    export type PutPatientsPatientIdPackagesPatientPackageIdVisitsMutationBody = PatientPackageVisitsAdjustmentAdminApiInContract
    export type PutPatientsPatientIdPackagesPatientPackageIdVisitsMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Adjusts the remaining visit balance on a patient's package by a signed delta per visit type and records an
audit entry. The whole request is applied together, so an invalid entry leaves every balance untouched.
 */
export const usePutPatientsPatientIdPackagesPatientPackageIdVisits = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdPackagesPatientPackageIdVisits>>, TError,{patientId: string;patientPackageId: string;data: PatientPackageVisitsAdjustmentAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPatientsPatientIdPackagesPatientPackageIdVisits>>,
        TError,
        {patientId: string;patientPackageId: string;data: PatientPackageVisitsAdjustmentAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPutPatientsPatientIdPackagesPatientPackageIdVisitsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
| HTTP status | ErrorCode       | Description                                                  |
|-------------|-----------------|--------------------------------------------------------------|
| 403         | Permission      | The admin lacks the patient.package.edit permission.         |
| 404         | PatientNotFound | The patient could not be found.                              |
| 404         | PackageNotFound | The patient holds no package with the specified identifier.  |
| 409         | PackageExpired  | The package is already inactive.                             |
 * @summary Cancels a patient's package, ending its validity now so it stops covering visits. The purchase and its
balance stay on record and no money moves. An optional free-text reason is stored on the package.
 */
export const deletePatientsPatientIdPackagesPatientPackageId = (
    patientId: string,
    patientPackageId: string,
    patientPackageCancellationAdminApiInContract: PatientPackageCancellationAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/packages/${encodeURIComponent(String(patientPackageId))}`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: patientPackageCancellationAdminApiInContract
    },
      options);
    }
  


export const getDeletePatientsPatientIdPackagesPatientPackageIdMutationOptions = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePatientsPatientIdPackagesPatientPackageId>>, TError,{patientId: string;patientPackageId: string;data: PatientPackageCancellationAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePatientsPatientIdPackagesPatientPackageId>>, TError,{patientId: string;patientPackageId: string;data: PatientPackageCancellationAdminApiInContract}, TContext> => {

const mutationKey = ['deletePatientsPatientIdPackagesPatientPackageId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePatientsPatientIdPackagesPatientPackageId>>, {patientId: string;patientPackageId: string;data: PatientPackageCancellationAdminApiInContract}> = (props) => {
          const {patientId,patientPackageId,data} = props ?? {};

          return  deletePatientsPatientIdPackagesPatientPackageId(patientId,patientPackageId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePatientsPatientIdPackagesPatientPackageIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePatientsPatientIdPackagesPatientPackageId>>>
    export type DeletePatientsPatientIdPackagesPatientPackageIdMutationBody = PatientPackageCancellationAdminApiInContract
    export type DeletePatientsPatientIdPackagesPatientPackageIdMutationError = void | ErrorDescription | ErrorApiOutContract

    /**
 * @summary Cancels a patient's package, ending its validity now so it stops covering visits. The purchase and its
balance stay on record and no money moves. An optional free-text reason is stored on the package.
 */
export const useDeletePatientsPatientIdPackagesPatientPackageId = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePatientsPatientIdPackagesPatientPackageId>>, TError,{patientId: string;patientPackageId: string;data: PatientPackageCancellationAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePatientsPatientIdPackagesPatientPackageId>>,
        TError,
        {patientId: string;patientPackageId: string;data: PatientPackageCancellationAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getDeletePatientsPatientIdPackagesPatientPackageIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    